import { ClassificationCode } from "@/types/code.types";
import { ArticleInfo } from "@interface/articleInfo.interface";

import { ArticleInfoResponse } from "./articleInfo.interface";

export const adaptArticleInfoData = (
  info: ArticleInfoResponse,
): ArticleInfo => {
  if (info?.publicationId) {
    return {
      ...info,
      affiliation:
        info.affiliation.filter((data) => data !== "")?.join(", ") || "",
      classificationAi: (info.topicType as ClassificationCode) || "P999",
      classificationManual: (info.topicType as ClassificationCode) || "P999",
      classificationAiName: "Publication",
      classificationManualName: "Publication",
      pressTitle: info?.title || "",
      pressUrl: info?.publicationUrl || "",
    };
  }

  if (info?.registryUrl || info?.registryDate) {
    return {
      ...info,
      pressTitle: info?.title || "",
      pressUrl: info?.registryUrl || "",
      classificationAi: info.registryAgency as ClassificationCode,
      classificationManual: info.registryAgency as ClassificationCode,
      id: info.id,
      registryId: info.registryId,
      registryDate: info.registryDate,
      registryAgency: info.registryAgency,
    };
  }
  const targetReviewRequiredInformationList =
    info?.reviewInformationList?.filter(({ deleted }) => deleted !== true);

  return {
    ...info,
    reviewIdList:
      targetReviewRequiredInformationList?.map((data) =>
        Number(data.reviewId),
      ) || [],
    isReviewRequired: targetReviewRequiredInformationList?.length > 0,
  };
};
